import React, { forwardRef } from 'react';
import { CheckboxInput, HelperText } from './Checkbox.styles';

type CheckboxProps = React.ComponentProps<'input'> & {
  label?: string;
  helperText?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, helperText, ...rest }, ref) => {
    return (
      <div>
        <CheckboxInput {...rest} type="checkbox" ref={ref} />
        <label htmlFor={rest.id}>{label}</label>
        {helperText && <HelperText>{helperText}</HelperText>}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
